import React, { useEffect, useState } from "react";
import { readinessHex } from "../isf/commandCenterModel";
import { buildSchedulePreviewReport } from "./schedulePreviewChecklist";

export default function ScheduleReadinessTopBadge({
  wizard,
  cohort,
  scheduleCreated = false,
  visitBuilderMode,
  visitCohorts,
  studyScheduleId,
  organizationId,
  createdBy,
  refreshKey = 0,
}) {
  const [loading, setLoading] = useState(false);
  const [percent, setPercent] = useState(null);

  useEffect(() => {
    if (!scheduleCreated || !studyScheduleId || !organizationId) {
      setPercent(null);
      return undefined;
    }

    let cancelled = false;
    const timer = window.setTimeout(async () => {
      setLoading(true);
      try {
        const report = await buildSchedulePreviewReport({
          wizard,
          cohort,
          scheduleCreated,
          visitBuilderMode,
          visitCohorts,
          studyScheduleId,
          organizationId,
          createdBy,
        });
        if (cancelled) return;
        const summary = report?.summary || {};
        const nextPercent =
          summary.total > 0
            ? Math.round((summary.complete / summary.total) * 100)
            : 0;
        setPercent(nextPercent);
      } catch {
        if (!cancelled) setPercent(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, 350);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [
    cohort,
    createdBy,
    organizationId,
    refreshKey,
    scheduleCreated,
    studyScheduleId,
    visitBuilderMode,
    visitCohorts,
    wizard,
  ]);

  if (!scheduleCreated) return null;

  const displayPercent = loading && percent == null ? null : percent ?? 0;
  const color = readinessHex(displayPercent ?? 0);

  return (
    <div
      className="schedule-readiness-top schedule-readiness-top--inline"
      title="Schedule setup completeness based on enabled checks"
      aria-label={
        displayPercent == null
          ? "Checking schedule completeness"
          : `Schedule ${displayPercent}% complete`
      }
    >
      <div className="schedule-readiness-top__bar" aria-hidden>
        <span
          className="schedule-readiness-top__bar-fill"
          style={{
            width: `${displayPercent ?? 0}%`,
            background: color,
          }}
        />
      </div>
      <span className="schedule-readiness-top__text">
        {displayPercent == null ? (
          <i className="fas fa-spinner fa-spin" aria-hidden />
        ) : (
          <>
            <strong style={{ color }}>{displayPercent}%</strong>
            <span>Complete</span>
          </>
        )}
      </span>
    </div>
  );
}
